
import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-remove-element-classes]';
export const PLUGIN_NAME = 'RemoveElementClasses';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--remove-element-classes" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__remove-element-classes/index.js